module.exports = __webpack_public_path__ + "static/media/2-IMG_6683.f170d585.JPG";